(function () {

  /* ── Copy to clipboard ───────────────────────────────── */
  var _toast = null;
  var _toastTimer = null;
  var _toastBtn = null;

  function getToast() {
    if (!_toast) {
      _toast = document.createElement('span');
      _toast.className = 'offer-card__toast';
      _toast.setAttribute('role', 'status');
      _toast.setAttribute('aria-live', 'polite');
      _toast.textContent = 'Copied!';
      document.body.appendChild(_toast);
    }
    return _toast;
  }

  function updateToastPosition() {
    if (!_toast || !_toastBtn || !_toast.classList.contains('is-visible')) return;
    var rect = _toastBtn.getBoundingClientRect();

    // Position fixed above the icon, centered on it
    _toast.style.left = (rect.left + rect.width / 2) + 'px';
    _toast.style.top  = (rect.top - 8) + 'px';
  }

  function showToast(btn) {
    var toast = getToast();
    _toastBtn = btn;
    updateToastPosition();

    if (_toastTimer) clearTimeout(_toastTimer);
    toast.classList.remove('is-visible');

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toast.classList.add('is-visible');
        updateToastPosition();
      });
    });

    _toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      _toastBtn = null;
    }, 2500);
  }

  // Keep the toast glued to its button as the page or the card track scrolls.
  // Capture phase so it also fires for scroll on the horizontally-scrolling
  // .offer-cards__track (scroll events don't bubble).
  window.addEventListener('scroll', updateToastPosition, true);
  window.addEventListener('resize', updateToastPosition);

  function copyCode(btn) {
    var code = btn.dataset.code;

    function onSuccess() { showToast(btn); }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(onSuccess).catch(function () {
        fallbackCopy(code, onSuccess);
      });
    } else {
      fallbackCopy(code, onSuccess);
    }
  }

  function fallbackCopy(text, callback) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;pointer-events:none';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    try { document.execCommand('copy'); callback(); } catch (e) {}
    document.body.removeChild(ta);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.offer-card__copy');
    if (btn) copyCode(btn);
  });

  /* ── Desktop: wheel → horizontal scroll ─────────────── */
  document.addEventListener('wheel', function (e) {
    var track = e.target.closest('.offer-cards__track');
    if (!track) return;
    if (track.scrollWidth <= track.clientWidth) return;
    e.preventDefault();
    track.scrollLeft += e.deltaY + e.deltaX;
  }, { passive: false });

  /* ── Desktop: click-drag to scroll ──────────────────── */
  (function () {
    var dragging = false, startX, startScrollLeft, activeTrack;

    document.addEventListener('mousedown', function (e) {
      var track = e.target.closest('.offer-cards__track');
      if (!track) return;
      dragging = true;
      activeTrack = track;
      startX = e.pageX - track.getBoundingClientRect().left;
      startScrollLeft = track.scrollLeft;
      track.style.userSelect = 'none';
    });

    document.addEventListener('mousemove', function (e) {
      if (!dragging || !activeTrack) return;
      var x = e.pageX - activeTrack.getBoundingClientRect().left;
      activeTrack.scrollLeft = startScrollLeft - (x - startX);
    });

    function stopDrag() {
      if (!activeTrack) return;
      activeTrack.style.userSelect = '';
      dragging = false;
      activeTrack = null;
    }

    document.addEventListener('mouseup', stopDrag);
    document.addEventListener('mouseleave', stopDrag);
  })();

})();
